module.exports = __webpack_public_path__ + "officialStatic/img/solution-bg.c4e8bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-bg.png
// module id = iY6+
// module chunks = 0